import React, { Component } from "react";
import { Panel, Button } from 'react-bootstrap';
import { GenericSelectableTable } from "./GenericSelectableTable";
import { SearchHelper } from '../../helpers/SearchHelper';

export class PathSelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openPanels: {},
            filter: {},
            usePriorityPaths: false,
            selectedPathsByLine: {}
        };
    }

    componentDidMount() {
        let newOpenPanels = {};
        this.props.lines.forEach(line => {
            newOpenPanels[line.id] = this.props.usePriorityPaths;
        });

        this.setState({
            usePriorityPaths: this.props.usePriorityPaths,
            openPanels: newOpenPanels
        });
    }

    groupPathsByLine(paths, lines) {
        const grouped = lines.map(line => ({
            line: line,
            paths: []
        }));

        paths.forEach(p => {
            const group = grouped.find(g => g.line.id === p.line.id);
            if (group) {
                group.paths.push(p);
            }
        });

        return grouped;
    }

    onSearch(e, lineId) {
        const { filter } = this.state;
        filter[lineId] = e;

        this.setState({
            filter: filter
        });
    }


    onSelectEverything(filteredPaths = undefined) {
        const { paths } = this.props;
        const { selectedPathsByLine } = this.state;

        const itemsToConsider = filteredPaths || paths;
        const allCurrentlySelected = Object.values(selectedPathsByLine).flat();

        const filteredIds = itemsToConsider.map(path => path.id);
        const selectedFilteredPaths = allCurrentlySelected.filter(path =>
            filteredIds.includes(path.id)
        );

        const allFilteredSelected = selectedFilteredPaths.length === itemsToConsider.length && itemsToConsider.length > 0;

        let allSelectedPaths;
        let updatedSelectedPathsByLine = {};

        if (allFilteredSelected) {
            const filteredIdsSet = new Set(filteredIds);
            allSelectedPaths = allCurrentlySelected.filter(path =>
                !filteredIdsSet.has(path.id)
            );
        } else {
            const existingIds = new Set(allCurrentlySelected.map(path => path.id));
            const newPaths = itemsToConsider.filter(path => !existingIds.has(path.id));
            allSelectedPaths = [...allCurrentlySelected, ...newPaths];
        }

        allSelectedPaths.forEach(path => {
            const lineId = path.lineId; 
            if (!updatedSelectedPathsByLine[lineId]) {
                updatedSelectedPathsByLine[lineId] = [];
            }
            updatedSelectedPathsByLine[lineId].push(path);
        });

        this.setState({
            selectedPathsByLine: updatedSelectedPathsByLine
        });

        this.props.onPathsChange(allSelectedPaths);
    }

    onSelectAll(lineId, paths, filteredPaths = undefined) {
        const { selectedPathsByLine } = this.state;
        const selected = selectedPathsByLine[lineId] || [];

        const itemsToConsider = filteredPaths || paths;

        const filteredIds = itemsToConsider.map(path => path.id);
        const selectedFilteredPaths = selected.filter(path =>
            filteredIds.includes(path.id)
        );

        const allFilteredSelected = selectedFilteredPaths.length === itemsToConsider.length && itemsToConsider.length > 0;

        let newSelection;
        if (allFilteredSelected) {
            const filteredIdsSet = new Set(filteredIds);
            newSelection = selected.filter(path => !filteredIdsSet.has(path.id));
        } else {
            const existingIds = new Set(selected.map(path => path.id));
            const newPaths = itemsToConsider.filter(path => !existingIds.has(path.id));
            newSelection = [...selected, ...newPaths];
        }

        const updatedSelectedPathsByLine = {
            ...selectedPathsByLine,
            [lineId]: newSelection
        };

        this.setState({
            selectedPathsByLine: updatedSelectedPathsByLine
        });

        const allSelectedPaths = Object.values(updatedSelectedPathsByLine).flat();
        this.props.onPathsChange(allSelectedPaths);
    }

    onRowClick(lineId, path) {
        const { onRowClick } = this.props;
        const { selectedPathsByLine } = this.state;

        const current = selectedPathsByLine[lineId] || [];
        const index = current.findIndex(data => data.id === path.id);

        let newSelection;
        if (index === -1) {
            newSelection = [...current, path];
        } else {
            newSelection = [
                ...current.slice(0, index),
                ...current.slice(index + 1)
            ];
        }

        this.setState({
            selectedPathsByLine: {
                ...selectedPathsByLine,
                [lineId]: newSelection
            }
        });

        onRowClick(path);
    }

    onPanelToggle(lineId) {
        this.setState(prev => ({
            openPanels: {
                ...prev.openPanels,
                [lineId]: !prev.openPanels[lineId]
            }
        }));
    }

    onPriorityPathToggle() {
        const { usePriorityPaths } = this.state;
        const newValue = !usePriorityPaths;

        let newOpenPanels = {};
        this.props.lines.forEach(line => {
            newOpenPanels[line.id] = newValue;
        });

        this.setState({
            usePriorityPaths: newValue,
            openPanels: newOpenPanels
        }, () => {
            this.props.onSelectPriorityPaths(newValue);
        });
    }

    render() {
        const { paths, lines, shouldAggregatePaths } = this.props;
        const { filter, openPanels, usePriorityPaths } = this.state;

        const grouped = this.groupPathsByLine(paths, lines);

        return (
            <div>
                <div className="schematicmap-options-container">
                    <div>
                        <div className={`schematicmap-option ${usePriorityPaths ? "active" : ""}`} onClick={() => this.onPriorityPathToggle()} >
                            <input
                                type="checkbox"
                                checked={usePriorityPaths}
                                onChange={() => this.onPriorityPathToggle()}
                                className="schematicmap-checkbox"
                            />
                            <span className="schematicmap-label">Utilizar apenas percurso principal</span>
                        </div>

                        <div className={`schematicmap-option ${shouldAggregatePaths ? "active" : ""}`} >
                            <input
                                type="checkbox"
                                checked={shouldAggregatePaths}
                                onChange={() => this.props.onAggregatePathsToggle()}
                                className="schematicmap-checkbox"
                                disabled={true}
                            />
                            <span className="schematicmap-label">Agregar percursos selecionados por cor</span>
                        </div>
                    </div>

                    <Button className="col-xs-auto" onClick={() => this.onSelectEverything()} disabled={usePriorityPaths} >
                        Selecionar Tudo
                    </Button>
                </div>
                
                {grouped.map(group => {
                    const isOpen = !openPanels[group.line.id];

                    let pathsFiltered = SearchHelper.search({
                        filter: undefined === filter[group.line.id] ? "" : filter[group.line.id],
                        data: group.paths,
                        fields: ["code", "name"]
                    });

                    return (
                    <Panel key={group.line.id} className="schematicmap-path-panel">
                        <Panel.Heading
                                onClick={() => {
                                    if (!usePriorityPaths) {
                                        this.onPanelToggle(group.line.id);
                                    }
                                }}
                                className={`schematicmap-path-panel-header ${usePriorityPaths ? "disabled" : ""}`}>
                            <span>
                                {`${group.line.code} | ${group.line.goName}`}
                            </span>
                            <span className={`schematicmap-dropdown-span ${isOpen ? 'open' : 'closed'}`}> ▶ </span>
                        </Panel.Heading>

                        <Panel.Collapse in={isOpen}>
                            <div className="schematicmap-panel-collapse" style={{ minHeight: '300px' }}>
                                {group.paths.length > 0 ? (
                                    <GenericSelectableTable
                                        data={pathsFiltered}
                                        onSearch={(filter) => this.onSearch(filter, group.line.id)}
                                        onRowClick={(row) => this.onRowClick(group.line.id, row)}
                                        isRowSelected={(row) => this.props.isRowSelected(row)}
                                        renderCell={row => `${row.code} (${row.pathIdentifier})`}
                                        onSelectAll={() => { this.onSelectAll(group.line.id, group.paths, pathsFiltered) }}
                                        sortableFields={[
                                            { value: "code", label: "Código" }
                                        ]}
                                    />
                                ) : (
                                    <div className="schematicmap-panel-collapse-no-info">
                                        Sem percursos disponiveis para esta linha.
                                    </div>
                                )}
                            </div>
                        </Panel.Collapse>
                    </Panel>
                    );
                })}
            </div>
        )
    }
}
